<template>
  <b-navbar id="py-nav" variant="light" type="light" fixed="top">
    <b-navbar-nav class="pr-1 pr-sm-2 mx-auto">
      <b-navbar-brand :href="website" target="_blank" tag="h1" class="mr-0 pt-1 pt-lg-3">
        <b-img id="tp-nav-img" :src="vendor.company_logo_url" class="d-inline-block mr-2" fluid :alt="vendor.name"></b-img>
      </b-navbar-brand>
      <p class="tp-nav-title pt-2 pt-md-1 pt-lg-0">{{ vendor.name }}</p>
    </b-navbar-nav>
    <b-navbar-nav class="mx-auto">
      <b-nav-item v-if="facebook" :href="facebook" target="_blank" class="pt-1 pt-lg-2 px-md-4"><font-awesome-icon class="nav-fa-icon" :icon="['fab', 'facebook']" /></b-nav-item>
      <b-nav-item v-if="instagram" :href="instagram" target="_blank" class="pt-1 pt-lg-2 px-md-4"><font-awesome-icon class="nav-fa-icon" :icon="['fab', 'instagram']" /></b-nav-item>
      <p class="mr-0 pl-sm-2 pt-2 pt-md-1 pt-lg-0">
        <b-button class="tp-nav-title p-sm-2" pill variant="outline-dark" size="sm" @click="emitSideBar()">order total: {{ orderline_total | toCurrency }}</b-button>
      </p>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
export default {
  name: 'Nav',
  props: ['orderline_total'],
  data() {
    return {
      vendor_id: Number(process.env.VUE_APP_VENDOR_ID),
      vendor: [],
    }
  },

  computed: {
    website: function() {
      if (Object.keys(this.vendor).length > 0) {
        const web = this.vendor.vendor_addresses.filter(addr => addr.address_type_id==8);
        if (web[0]==undefined) {
          return '';
        } else {
          return web[0].address;
        }
      } else {
        return '';
      }
    },

    facebook: function() {
      if (Object.keys(this.vendor).length > 0) {
        const fb = this.vendor.vendor_addresses.filter(addr => addr.address_type_id==9);
        if (fb[0]==undefined) {
          return '';
        } else {
          return fb[0].address;
        }
      } else {
        return '';
      }
    },

    instagram: function() {
      if (Object.keys(this.vendor).length > 0) {
        const insta = this.vendor.vendor_addresses.filter(addr => addr.address_type_id==11);
        if (insta[0]==undefined) {
          return '';
        } else {
          return insta[0].address;
        }
      } else {
        return '';
      }
    }
  },

  methods: {
    emitSideBar() {
      this.$emit('emit-sidebar');
    },

    retrieveLocations() {
      // fetch locations
      this.$api.get('vendor/'+this.vendor_id+'/locations')
      .then(response => {
       // JSON responses are automatically parsed.
       this.vendor = response.data.locations[0].vendor;
      })
      .catch(e => {
       this.errors.push(e)
       console.log(this.errors)
      })
    },

  },

  created: function() {
    this.retrieveLocations();
  }

}
</script>

<style>


</style>
